import styled from 'styled-components'
import { PaddingContainer, FlexColumn } from 'components/common/common_styles'
import { Label } from 'components/common/typography'
import { sizeMobile } from 'components/globalStyles'
import RichText from 'components/common/richText'

export const MainContainer = styled(PaddingContainer)`
  display: grid;
  grid-template-areas:
    'menu mailing'
    'copyright social';
  row-gap: 32px;
  justify-content: space-between;
  align-items: start;
  color: white;

  & a {
    color: white;
  }

  @media (max-width: ${sizeMobile}) {
    row-gap: 48px;
    grid-template-columns: 1fr;
    grid-template-areas:
      'menu'
      'mailing'
      'social'
      'copyright';
  }
`

export const MenuContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  column-gap: clamp(48px, 5.357vw + 6.857px, 84px);
  row-gap: 28px;
  width: fit-content;
  grid-area: menu;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, auto);
  }

  @media (max-width: ${sizeMobile}) {
    row-gap: 32px;
    column-gap: 16px;
    justify-content: space-between;
    width: 100%;
  }
`

export const CopyrightContainer = styled(Label)`
  grid-area: copyright;
  align-self: end;

  @media (max-width: ${sizeMobile}) {
    justify-self: center;
  }
`

export const MailingContainer = styled(FlexColumn)`
  grid-area: mailing;
`

export const MailingList = styled.div`
  min-width: 400px;
  min-height: 70px;

  & button {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  & input[type='email'] {
    min-width: 250px !important;
  }

  & p > span {
    font-family: Proxima !important;
    font-weight: 600 !important;
    font-size: 2rem !important;
    color: white !important;
  }

  @media (max-width: ${sizeMobile}) {
    width: 100%;
    min-width: auto;
    min-height: auto;
  }
`

export const IconContainer = styled.div`
  display: flex;
  gap: 16px;
  grid-area: social;

  @media (max-width: ${sizeMobile}) {
    justify-self: center;
  }
`

export const AddressText = styled(RichText)`
  & p {
    font-family: Proxima;
    font-size: 1.4rem;
    line-height: 1.7rem;

    @media (max-width: ${sizeMobile}) {
      font-size: 1.6rem;
      line-height: 2rem;
    }
  }
`
